import { DistanceUnit, distanceUnitMap } from '~/constants/distance';
import { WeightUnit, weightUnitMap } from '~/constants/weight';

export const defaultWeightUnit = weightUnitMap[WeightUnit.LB];
export const defaultDistanceUnit = distanceUnitMap[DistanceUnit.IN];

export function weightOptionsBuilder() {
  return Object.keys(weightUnitMap).map((weightunit) => ({ label: weightunit, value: weightunit }));
}

export function distanceOptionsBuilder() {
  return Object.keys(distanceUnitMap).map((distanceUnit) => ({
    label: distanceUnit,
    value: distanceUnit,
  }));
}
